import { SevenBytesPostSurvey } from '../CreateSurveyComponents/MainSurveyComponensts/SevenBytesPostSurvey';

export const PreviewPostSurvey = () => {
    //get sessionStorage data
    const postSurveyData = JSON.parse(localStorage.getItem("postSurveyData"));

    return (
        <SevenBytesPostSurvey
            key={"sevenBytesPostSurvey"}
            survey={postSurveyData}
        />
    )
}
